export default "__VITE_ASSET__DPhoAYUx__ 400w, __VITE_ASSET__DEb4n3o1__ 800w, __VITE_ASSET__SCeXevzB__ 1024w";